import { NodeModel } from "../_model/NodeModel";
import Properties from "../_model/ModelEngineeringProperties"
import { DecorationCurrent } from "./decorationCurrent"
import { Types } from "../../utils/nodeTypes"
import EquationRef from "../_model/EquationModel";

class Current extends NodeModel {
  constructor(location = {x: 0, y: 0}) {
    super("Current");
    
    this.type = new Types().Current
    this.connectionPack = new Array();
    this.x = location.x;
    this.x = location.y;
    this.width = 100;
    this.height = 20;
    this.title = "Caixa de Texto"
    this.dataType = '',
    this.data = []
    this.bkpData = []
    this.refActive = true
    this.ref = EquationRef
    
    this.xText = () => this.x + (this.width / 2);
    this.yText = () => this.y - 20;
    this.yBoxBody = () => this.y + 20;
    
    this.decorate = async function(callback) {
      this.decorator = new DecorationCurrent();
      await this.decorator.init(this, callback)
    }

    this.update = (nodeEdited) => {
      this.title = nodeEdited.title
      this.dataType = nodeEdited.dataType
      let isDiff = false
      
      if(this.bkpData.length == nodeEdited.attrs.length){
        this.bkpData.forEach((a, i) => {
          if(a.isEquals(nodeEdited.attrs[i]))
          isDiff = true
        })
      }

      if(isDiff)
        this.bkpData = []

      if(nodeEdited.attrs){
        this.addNewAttrs(nodeEdited.attrs)
      }

      this.expressionVisible = nodeEdited.expressionVisible
      this.refActive = nodeEdited.refActive

      this.decorator.setTextAndAdjustWidth()
    }

    this.addNewAttrs = (attrs) => {
      this.height = 0;
      let textAttrs = new Array();
      attrs.forEach(attr => {
        this.height += 20;
        textAttrs.push(new Properties({...attr, height: this.height}))
      });
      this.data = textAttrs
    }

    this.clone = () => {
      let cloned = new Current();
      cloned.id = this.id
      cloned.idName = this.idName
      cloned.type = this.type
      cloned.x = this.x
      cloned.y = this.y
      cloned.width = this.width
      cloned.title = this.title
      cloned.readOnly = this.readOnly
      cloned.data = this.cloneData()
      cloned.dataType = this.dataType
      cloned.refActive = !!this.refActive
      cloned.expressionVisible = this.expressionVisible
      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.title = node.title;
      this.dataType = node.dataType
      this.refActive = node.refActive
      this.data = node.data.map(d => new Properties({...d}))
    }

    this.cloneData = function(){
      return this.bkpData.length ? this.bkpData.map(d => d.clone()) : this.data.map(d => d.clone())
    }

    this.removeConnection = (connectionId) => {
      this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
    }

    this.reloadProperties = async function() {
      if (this.data && this.data.length > 0) {
          for(let i in this.ref){
            let p = this.data[i]
            let result = await p.refCalc.calc(p.mapping) 
            p.setResultCalc(result)
          }

          for(let i in this.data){
              let p = this.data[i]
              let result = await p.refCalc.calc(p.mapping) 
              p.setResultCalc(result)

          }
          this.decorator.reloadProperties();
      }
  }

    this.setReference = function (prop){
      if(!this.refActive) return

      if(prop)
      {
        if(!this.bkpData.length) this.bkpData = this.data;
        let model = this.ref.get(prop.key)
        let result = model.calc(prop.mapping)
        prop.setResultCalc(result)
        this.data = [prop]
        this.addNewAttrs(this.data)
      }
      else if(this.bkpData.length){
          this.addNewAttrs(this.bkpData)
          this.data = this.bkpData
          this.bkpData = []
      }
      this.decorator.setTextAndAdjustWidth()
    }
  }
}


export { Current };
